import Users from '@/views/Users'
import Create from '@/views/users/Create'
import Page from '@/views/users/Page'

export default [
  {
    path: '/users',
    component: Users,
    meta: {
      title: 'Пользователи',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/users/create',
    component: Create,
    meta: {
      title: 'Пользователи',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/users/:userId',
    component: Page,
    name: 'userPage',
    props: true,
    meta: {
      title: 'Пользователи',
      layout: 'BaseWorkspaceLayout'
    }
  }
]
